import { useLang, copy } from "@/i18n";

export default function Marquee() {
  const { lang } = useLang();
  const text = copy[lang].marquee;

  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y py-8"
      style={{ borderColor: "var(--line-soft)", background: "rgba(6, 6, 5, 0.45)" }}
    >
      <div className="marquee-track flex whitespace-nowrap">
        {[0, 1].map((n) => (
          <span
            key={n}
            aria-hidden={n === 1}
            className="font-serif-fmf font-light italic text-xl md:text-2xl tracking-[0.2em] text-[var(--graphite)] pr-4"
          >
            {text.repeat(4)}
          </span>
        ))}
      </div>
    </div>
  );
}
